<nz-divider></nz-divider>
<form nz-form *ngIf="load" [nzLayout]="'vertical'" [formGroup]="moreInfoForm">
  <div nz-row [nzGutter]="{ xs: 8, sm: 8, md: 8, lg: 24, xl: 48, xxl: 48 }">
    <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item>
        <nz-form-label nzFor="approvalStatus" nzRequired>More Information
          <span nz-tooltip nzTitle="Approval Status">
            <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
          </span>
        </nz-form-label>
        <nz-form-control [nzErrorTip]="'Approval Status is Required'">
          <nz-select required [nzPlaceHolder]="'Approval Status'" id="approvalStatus" formControlName="approvalStatus"
             nzId="approvalStatus" [nzShowSearch]="true">
            <nz-option *ngFor="let i of approvalStatusList" [nzLabel]="i.label" [nzValue]="i.label"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item>
        <nz-form-label nzFor="comments">Comments
          <span nz-tooltip nzTitle="Comments">
            <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
          </span>
        </nz-form-label>
        <nz-form-control [nzErrorTip]="'Comments is Required'">
          <textarea required rows="2" id="comments" formControlName="comments" nz-input id="comments"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>
  <div nz-col nzXl="24" nzLg="24"nzMd="24" nzSm="24" nzXs="24">
    <div class="float-right">
      <button nz-button id="onSubmit" (click)="onSubmit()">Submit</button>
    </div>
  </div>
  </div>
</form>
